const ERROR_CONSTANTS = {
  NO_CREDIT_LINE_FOUND: 'NO_CREDIT_LINE_FOUND',
  NOT_ENOUGH_CREDIT_LINE_BALANCE: 'NOT_ENOUGH_CREDIT_LINE_BALANCE',
  // FU-082. The credit-line gate itself failed on an enforcing (or undeterminable) cap, so the
  // account payment was refused. RETRYABLE, answered 503 — not a statement that the line is full.
  CREDIT_LINE_CHECK_UNAVAILABLE: 'CREDIT_LINE_CHECK_UNAVAILABLE',
};

module.exports = {
    ERROR_CONSTANTS
}
